import { connect } from "react-redux";

import StringControlWithUnit from "./StringControlWithUnit";

export default connect((state, ownProps) => ({
	units: state.units,
	...ownProps
}))(StringControlWithUnit);
